/* CPS Warranty Promotion
 * Three surfaces:
 *  1. PDP: wraps the CPS-injected widget (div.cps_cart) in a value-messaging card
 *  2. Popup: after an eligible product is added to cart with no warranty, offer 2yr/3yr
 *  3. Cart page: inline "add protection" offer under the line items
 *
 * Warranty products are normal Shopify products, price-banded (TAB2/TAB3 SKUs).
 * If CPS pricing changes, update the BANDS table below.
 */
(function () {
  'use strict';

  // maxCents = upper bound of the band (inclusive). Prices in cents.
  var BANDS = [
    { maxCents: 24999,  y2: { id: 19728819585111, price: 1995 },  y3: { id: 19728882827351, price: 2995 } },
    { maxCents: 49999,  y2: { id: 19728824303703, price: 3195 },  y3: { id: 19728887349335, price: 4295 } },
    { maxCents: 74999,  y2: { id: 19728830627927, price: 5295 },  y3: { id: 19728889872471, price: 6995 } },
    { maxCents: 99999,  y2: { id: 19728834854999, price: 6995 },  y3: { id: 19728891445335, price: 9495 } },
    { maxCents: 149999, y2: { id: 19728847994967, price: 8495 },  y3: { id: 19728895344727, price: 11295 } },
    { maxCents: 199999, y2: { id: 19728855826519, price: 11495 }, y3: { id: 19728896622679, price: 14995 } },
    { maxCents: 249999, y2: { id: 19728856612951, price: 12995 }, y3: { id: 19728900390999, price: 17495 } },
    { maxCents: 299999, y2: { id: 19728877289559, price: 15495 }, y3: { id: 19728902422615, price: 19995 } },
    { maxCents: 399999, y2: { id: 19728879353943, price: 18995 }, y3: { id: 19728905568343, price: 23995 } },
    { maxCents: 499999, y2: { id: 19728880631895, price: 22995 }, y3: { id: 19728912187479, price: 27495 } }
  ];

  var WARRANTY_SKU_RE = /^(TAB|CTE)\d/i;
  var WARRANTY_TITLE_RE = /\((ACC|Accidental)\)|Accidental Damage Warranty|Product Replacement|Cellular (Phone|Telephone)/i;
  var SESSION_KEY = 'cpsPopupDismissed';
  var PENDING_KEY = 'cpsPendingPlan';

  var config = window.CPSWarrantyConfig || {};
  var enablePopup = config.enablePopup !== false;
  var enableCartUpsell = config.enableCartUpsell !== false;
  var enablePdpCard = config.enablePdpCard !== false;

  var lastWarrantyAddAt = 0;

  function bandFor(cents) {
    for (var i = 0; i < BANDS.length; i++) {
      if (cents <= BANDS[i].maxCents) return BANDS[i];
    }
    return null;
  }

  function isWarrantyItem(item) {
    return WARRANTY_SKU_RE.test(item.sku || '') || WARRANTY_TITLE_RE.test(item.product_title || item.title || '');
  }

  function isWarrantyVariantId(id) {
    id = Number(id);
    return BANDS.some(function (b) { return b.y2.id === id || b.y3.id === id; });
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // variantId -> real Shopify variant price (cents), from BANDS
  var VARIANT_PRICE_CENTS = {};
  BANDS.forEach(function (b) {
    VARIANT_PRICE_CENTS[b.y2.id] = b.y2.price;
    VARIANT_PRICE_CENTS[b.y3.id] = b.y3.price;
  });

  // CPS's injected PDP widget displays dealer-config prices (whole dollars,
  // e.g. $70.00) but clicking a plan adds the Shopify warranty variant, which
  // is what's actually charged (e.g. $69.95). Rewrite each plan button's
  // displayed price to the real variant price. Buttons carry
  // warranty-attr="<shopify variant id>" — CPS's own add-to-cart flow reads
  // it, so it's a stable hook; unknown ids (e.g. "0" placeholders) no-op.
  function fixCpsWidgetPrices(widget) {
    var buttons = widget.querySelectorAll('button[warranty-attr]');
    Array.prototype.forEach.call(buttons, function (btn) {
      var cents = VARIANT_PRICE_CENTS[Number(btn.getAttribute('warranty-attr'))];
      if (!cents) return;
      var real = (cents / 100).toFixed(2);
      var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        var replaced = node.nodeValue.replace(/\d+\.\d{2}/g, real);
        // write only on change — a MutationObserver re-runs this on CPS
        // re-renders and unconditional writes would loop it
        if (replaced !== node.nodeValue) node.nodeValue = replaced;
      }
    });
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return getCart();
    }).then(function (cart) {
      window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
      return cart;
    });
  }

  // Highest-priced eligible (non-warranty, in-band) item in cart
  function eligibleItem(cart) {
    var best = null;
    (cart.items || []).forEach(function (item) {
      if (isWarrantyItem(item)) return;
      if (!bandFor(item.price)) return;
      if (!best || item.price > best.price) best = item;
    });
    return best;
  }

  function cartHasWarranty(cart) {
    return (cart.items || []).some(isWarrantyItem);
  }

  var BENEFITS = [
    'Covers drops, spills &amp; accidental damage',
    '$0 deductible &mdash; no fees to make a claim'
  ];

  function benefitsHtml() {
    return '<ul class="cps-promo__benefits">' + BENEFITS.map(function (b) {
      return '<li>' + b + '</li>';
    }).join('') + '</ul>';
  }

  /* ---------------- 1. PDP card ---------------- */

  function buildCard() {
    var card = document.createElement('div');
    card.className = 'cps-promo__card';
    card.innerHTML =
      '<div class="cps-promo__card-header">' +
        '<span class="cps-promo__shield" aria-hidden="true">&#128737;</span>' +
        '<span class="cps-promo__card-title">Protect your purchase</span>' +
      '</div>' +
      benefitsHtml() +
      '<div class="cps-promo__card-hint">Select a plan below, then add to cart:</div>';
    return card;
  }

  // Fallback when CPS's server returns no plans for this product (e.g. products
  // with "AppleCare" in the title are excluded in CPS's dealer config): render
  // our own 2yr/3yr buttons from the band table. The selected plan is added to
  // the cart when the product form is submitted.
  function renderPdpFallback(widget) {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    fetch(window.location.pathname + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (product) {
        function currentVariant() {
          var idInput = form.querySelector('[name="id"]');
          var id = idInput ? Number(idInput.value) : null;
          return product.variants.find(function (v) { return v.id === id; }) || product.variants[0];
        }
        if (WARRANTY_TITLE_RE.test(product.title)) return;
        var band = bandFor(currentVariant().price);
        if (!band) return;

        var card = buildCard();
        var choices = document.createElement('div');
        choices.className = 'cps-promo__pdp-choices';
        choices.innerHTML =
          '<button type="button" class="cps-promo__pdp-choice" data-cps-plan="' + band.y2.id + '">2 Years<br><strong>' + money(band.y2.price) + '</strong></button>' +
          '<button type="button" class="cps-promo__pdp-choice" data-cps-plan="' + band.y3.id + '">3 Years<br><strong>' + money(band.y3.price) + '</strong></button>';
        card.appendChild(choices);

        var selectedPlan = null;
        choices.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-cps-plan]');
          if (!btn) return;
          var id = Number(btn.getAttribute('data-cps-plan'));
          selectedPlan = selectedPlan === id ? null : id;
          choices.querySelectorAll('[data-cps-plan]').forEach(function (b) {
            b.classList.toggle('cps-promo__pdp-choice--selected', Number(b.getAttribute('data-cps-plan')) === selectedPlan);
          });
        });

        // Do NOT intercept the submit — the theme has its own add-to-cart
        // handling and re-submitting duplicates the product, and an in-flight
        // request dies when the theme redirects to /cart. Instead record the
        // chosen plan and complete the add on the cart page.
        function recordPending() {
          if (!selectedPlan) return;
          sessionStorage.setItem(PENDING_KEY, JSON.stringify({
            plan: selectedPlan,
            productId: product.id,
            ts: Date.now()
          }));
        }
        form.addEventListener('submit', recordPending);
        var atcBtn = form.querySelector('[type="submit"], [data-product-atc]');
        if (atcBtn) atcBtn.addEventListener('click', recordPending);

        if (widget) {
          widget.parentNode.insertBefore(card, widget);
          card.appendChild(widget); // keep container so CPS late-injection still lands inside the card
        } else {
          // CPS never injected its container — place the card above the ATC button
          var anchor = form.querySelector('.product-form--atc-button, [data-product-atc], [type="submit"]');
          if (!anchor) return;
          anchor.parentNode.insertBefore(card, anchor);
        }
      })
      .catch(function () {});
  }

  // Ask CPS's API directly (JSONP, same call their widget makes) whether this
  // variant has plans. cb(true)=has plans, cb(false)=none, cb(null)=unknown
  // (API unreachable/slow — fall back to watching the DOM).
  function checkCpsPlans(variantId, cb) {
    var done = false;
    var cbName = '__cpsPromoJsonp' + Math.floor(Math.random() * 1e9);
    var script = document.createElement('script');
    var timeout = setTimeout(function () { finish(null); }, 4000);
    function finish(result) {
      if (done) return;
      done = true;
      clearTimeout(timeout);
      delete window[cbName];
      if (script.parentNode) script.parentNode.removeChild(script);
      cb(result);
    }
    window[cbName] = function (data) {
      try {
        finish(data.response.data.length > 0);
      } catch (e) { finish(null); }
    };
    script.onerror = function () { finish(null); };
    script.src = 'https://app.cpscentral.com/vendor_product.ashx?value=get_new_warranty_shopify_app&variant=' +
      variantId + '&shop=computer-overhauls.myshopify.com&callback=' + cbName;
    document.head.appendChild(script);
  }

  function enhancePdpWidget() {
    if (!enablePdpCard) return;

    // Fast path: ask CPS directly. If it says "no plans", render our fallback
    // immediately instead of waiting out the DOM watcher below.
    var resolved = false;
    var form = document.querySelector('[data-product-form]');
    var idInput = form && form.querySelector('[name="id"]');
    if (idInput) {
      checkCpsPlans(idInput.value, function (hasPlans) {
        if (hasPlans === false && !resolved && !document.querySelector('.cps-promo__card')) {
          resolved = true;
          renderPdpFallback(document.querySelector('.cps_cart'));
        }
        // hasPlans === true or null: let the DOM watcher handle it
      });
    }

    var tries = 0;
    var timer = setInterval(function () {
      if (resolved) { clearInterval(timer); return; }
      var widget = document.querySelector('.product-form--regular .cps_cart, .cps_cart');
      tries++;
      if (widget && widget.querySelector('button')) {
        // CPS injected its plan buttons — wrap them in the card
        clearInterval(timer);
        fixCpsWidgetPrices(widget);
        new MutationObserver(function () { fixCpsWidgetPrices(widget); })
          .observe(widget, { childList: true, subtree: true, characterData: true });
        if (widget.closest('.cps-promo__card')) return;
        var card = buildCard();
        widget.parentNode.insertBefore(card, widget);
        card.appendChild(widget);
        return;
      }
      if (tries > 16) {
        // ~8s with no CPS buttons: assume CPS excluded this product, use fallback
        clearInterval(timer);
        if (!document.querySelector('.cps-promo__card')) renderPdpFallback(widget || null);
      }
    }, 500);
  }

  /* ---------------- 2. Add-to-cart popup ---------------- */

  function buildModal(item, band) {
    var overlay = document.createElement('div');
    overlay.className = 'cps-promo__overlay';
    overlay.innerHTML =
      '<div class="cps-promo__modal" role="dialog" aria-modal="true" aria-label="Add protection plan">' +
        '<button class="cps-promo__close" aria-label="Close">&times;</button>' +
        '<div class="cps-promo__card-header">' +
          '<span class="cps-promo__shield" aria-hidden="true">&#128737;</span>' +
          '<span class="cps-promo__card-title">Protect your new gear</span>' +
        '</div>' +
        '<p class="cps-promo__modal-sub">Add CPS accidental damage coverage for your <strong>' +
          (item.product_title || 'item').replace(/</g, '&lt;') + '</strong></p>' +
        benefitsHtml() +
        '<div class="cps-promo__choices">' +
          '<button class="cps-promo__choice" data-cps-add="' + band.y2.id + '"><span class="cps-promo__term">2-Year Plan</span><span class="cps-promo__price">' + money(band.y2.price) + '</span></button>' +
          '<button class="cps-promo__choice" data-cps-add="' + band.y3.id + '"><span class="cps-promo__term">3-Year Plan</span><span class="cps-promo__price">' + money(band.y3.price) + '</span></button>' +
        '</div>' +
        '<button class="cps-promo__decline">No thanks, I’ll risk it</button>' +
      '</div>';

    function close() {
      sessionStorage.setItem(SESSION_KEY, '1');
      overlay.remove();
    }

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.closest('.cps-promo__close') || e.target.closest('.cps-promo__decline')) {
        close();
        return;
      }
      var btn = e.target.closest('[data-cps-add]');
      if (btn) {
        btn.disabled = true;
        btn.classList.add('cps-promo__choice--busy');
        addToCart(Number(btn.getAttribute('data-cps-add'))).then(function () {
          var modal = overlay.querySelector('.cps-promo__modal');
          modal.innerHTML =
            '<div class="cps-promo__success">' +
              '<span class="cps-promo__shield" aria-hidden="true">&#9989;</span>' +
              '<p><strong>Protection added!</strong><br>Your coverage is in the cart.</p>' +
            '</div>';
          setTimeout(function () {
            close();
            if (document.querySelector('[data-cart-item-list]')) window.location.reload();
          }, 1600);
        }).catch(function () {
          btn.disabled = false;
          btn.classList.remove('cps-promo__choice--busy');
        });
      }
    });

    document.body.appendChild(overlay);
  }

  function maybeShowPopup(addedItem) {
    if (!enablePopup) return;
    if (sessionStorage.getItem(SESSION_KEY)) return;
    // Give CPS's own widget (or any follow-up add) time to add its warranty
    setTimeout(function () {
      if (Date.now() - lastWarrantyAddAt < 5000) return;
      getCart().then(function (cart) {
        if (cartHasWarranty(cart)) return;
        var item = addedItem && !isWarrantyItem(addedItem) && bandFor(addedItem.price)
          ? addedItem : eligibleItem(cart);
        if (!item) return;
        var band = bandFor(item.price);
        if (!band) return;
        if (document.querySelector('.cps-promo__overlay')) return;
        buildModal(item, band);
      });
    }, 1500);
  }

  function handleAddResponse(url, body) {
    try {
      var data = JSON.parse(body);
      var items = data.items || [data];
      var added = items[0];
      if (!added || !added.id) return;
      if (isWarrantyItem(added) || isWarrantyVariantId(added.variant_id || added.id)) {
        lastWarrantyAddAt = Date.now();
        // A warranty landed in the cart: remove any open popup / cart offer
        var ov = document.querySelector('.cps-promo__overlay');
        if (ov) ov.remove();
        var offer = document.querySelector('.cps-promo__cart-offer');
        if (offer) offer.remove();
        return;
      }
      maybeShowPopup(added);
    } catch (e) { /* non-JSON response, ignore */ }
  }

  function interceptCartAdd() {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (url.indexOf('/cart/add') !== -1) {
        p.then(function (res) {
          if (res.ok) res.clone().text().then(function (t) { handleAddResponse(url, t); });
        }).catch(function () {});
      }
      return p;
    };

    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (url && String(url).indexOf('/cart/add') !== -1) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) handleAddResponse(url, this.responseText);
        });
      }
      return origOpen.apply(this, arguments);
    };
  }

  // This theme redirects to /cart after add-to-cart, so AJAX interception never
  // fires on the standard PDP flow. Show the popup once on arrival at the cart.
  function maybeShowPopupOnCartPage() {
    if (!enablePopup) return;
    if (!document.querySelector('[data-cart-item-list]')) return;
    if (sessionStorage.getItem(SESSION_KEY)) return;
    setTimeout(function () {
      getCart().then(function (cart) {
        if (cartHasWarranty(cart)) return;
        var item = eligibleItem(cart);
        if (!item) return;
        if (document.querySelector('.cps-promo__overlay')) return;
        buildModal(item, bandFor(item.price));
      });
    }, 600);
  }

  /* ---------------- 3. Cart page offer ---------------- */

  function renderCartOffer() {
    if (!enableCartUpsell) return;
    var list = document.querySelector('[data-cart-item-list]');
    if (!list) return;

    getCart().then(function (cart) {
      var existing = document.querySelector('.cps-promo__cart-offer');
      if (existing) existing.remove();
      if (cartHasWarranty(cart)) return;
      var item = eligibleItem(cart);
      if (!item) return;
      var band = bandFor(item.price);

      var box = document.createElement('div');
      box.className = 'cps-promo__cart-offer';
      box.innerHTML =
        '<div class="cps-promo__cart-offer-text">' +
          '<span class="cps-promo__shield" aria-hidden="true">&#128737;</span>' +
          '<div><strong>Add accidental damage protection</strong>' +
          '<span class="cps-promo__cart-offer-sub">Drops &amp; spills covered &middot; $0 deductible</span></div>' +
        '</div>' +
        '<div class="cps-promo__cart-offer-buttons">' +
          '<button class="cps-promo__cart-btn" data-cps-add="' + band.y2.id + '">2 Years &middot; ' + money(band.y2.price) + '</button>' +
          '<button class="cps-promo__cart-btn" data-cps-add="' + band.y3.id + '">3 Years &middot; ' + money(band.y3.price) + '</button>' +
        '</div>';

      box.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cps-add]');
        if (!btn) return;
        btn.disabled = true;
        addToCart(Number(btn.getAttribute('data-cps-add'))).then(function () {
          window.location.reload();
        }).catch(function () { btn.disabled = false; });
      });

      list.parentNode.insertBefore(box, list.nextSibling);
    });
  }

  /* ---------------- init ---------------- */

  // Complete a warranty add recorded on the PDP (CPS-excluded products).
  // Returns true if it took over the cart page (it reloads after adding).
  function applyPendingPlan() {
    var raw = sessionStorage.getItem(PENDING_KEY);
    if (!raw) return false;
    if (!document.querySelector('[data-cart-item-list]')) return false;
    sessionStorage.removeItem(PENDING_KEY);
    var pending;
    try { pending = JSON.parse(raw); } catch (e) { return false; }
    if (!pending.plan || Date.now() - (pending.ts || 0) > 15 * 60 * 1000) return false;

    getCart().then(function (cart) {
      if (cartHasWarranty(cart)) return;
      var hasProduct = (cart.items || []).some(function (i) { return i.product_id === pending.productId; });
      if (!hasProduct) return;
      addToCart(pending.plan).then(function () { window.location.reload(); });
    });
    return true;
  }

  function init() {
    interceptCartAdd();
    enhancePdpWidget();
    if (applyPendingPlan()) return; // cart offer/popup re-evaluate after the reload
    renderCartOffer();
    maybeShowPopupOnCartPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
